import { getBrandFaviconUrl, isBrand, setBrand, setFavicon } from '@frontends/util-theme-provider';
import { createRoot } from 'react-dom/client';
import '@frontends/tools-styles-builder/fonts';
import '@/index.css';
import '@frontends/feature-demo-balance/style';
import App from '@/App.tsx';
import { getEntityConfig } from '@/hooks/useEntityConfig';
import { BRAND_ASSET_VERSION_QUERY } from '@/lib/brand';
import './lib/i18n';

const entity = getEntityConfig().VITE_ENTITY;

if (isBrand(entity)) {
  setBrand(entity);
  setFavicon(`${getBrandFaviconUrl(entity)}${BRAND_ASSET_VERSION_QUERY}`);
}

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
